import React, { useEffect, useState } from "react";
import { FormContainer } from "./styled";
import { Button, Typography, TextField } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import { validaCandidato, registro, login } from "../../requests/req_menu";
import { getPerfil } from "../../requests/req_perfil";
import { amb } from '../../requests/utils';
import Swal from "sweetalert2";

const FrmRegistro = ({ active, fncPostula, fncMobile }) => {
  const [frmValues, setFrmValues] = useState({});
  const [errores, setErrores] = useState({});
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setErrores({})
    let errors;
    if (frmValues.nombre.length == 0 || !frmValues.nombre.match(/^[ÁÉÍÓÚéúíáóñA-Za-z /s]*$/)) {
      errors = {
        ...errors,
        nombre: 'El campo nombre es incorrecto'
      };
    }
    if (frmValues.apellidoPaterno.length == 0 || !frmValues.apellidoPaterno.match(/^[ÁÉÍÓÚéúíáóñA-Za-z /s]*$/)) {
      errors = {
        ...errors,
        apellidoPaterno: 'El campo apellido paterno es incorrecto'
      };
    }
    if (frmValues.apellidoMaterno.length == 0 || !frmValues.apellidoMaterno.match(/^[ÁÉÍÓÚéúíáóñA-Za-z /s]*$/)) {
      errors = {
        ...errors,
        apellidoMaterno: 'El campo apellido materno es incorrecto'
      };
    }
    if (frmValues.codigoPostal.length == 0 || !frmValues.codigoPostal.match(/^[0-9]{5,5}$/)) {
      errors = {
        ...errors,
        codigoPostal: 'El campo código postal es incorrecto'
      };
    }
    if (frmValues.telefono1.length == 0 || !frmValues.telefono1.match(/^[0-9]{10,10}$/)) {
      errors = {
        ...errors,
        telefono1: 'El campo teléfono es incorrecto'
      };
    }
    if (!frmValues.Correo.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
      errors = {
        ...errors,
        Correo: 'Ingrese un correo válido'
      };
    }
    if (frmValues.Correo != frmValues.CorreoVF) {
      errors = {
        ...errors,
        CorreoVF: 'El correo no coincide'
      };
    }
    if (frmValues.Password.length == 0) {
      errors = {
        ...errors,
        Password: 'Ingrese su contraseña'
      }
    }
    if (errors) {
      setErrores({ ...errors });
      return false;
    }
    setLoading(true);
    let responseValidaCandidato = await validaCandidato(frmValues);
    if (responseValidaCandidato) {
      const aceptaCodinciones = await Swal.fire({
        title: '',
        icon: 'info',
        input: 'checkbox',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        target: "#modalPostulacion",
        inputPlaceholder: 'Acepto <a href="https://docreclutamiento.tiii.mx/AvisoPrivacidad/Aviso%20de%20Privacidad.pdf" target="_blank"> Aviso de Privacidad</a> '
      }).then(function (result) {
        return result.value;
      });
      if (aceptaCodinciones) {
        const responseRegistro = await registro(frmValues);
        if (responseRegistro) {
          const response = await login({ Correo: frmValues.Correo, Password: frmValues.Password });
          if (response) {
            var bs64 = btoa(unescape(encodeURIComponent(JSON.stringify(response))));
            sessionStorage.setItem(amb + '_User', bs64);
            getPerfil(data => {
              if (data) {
                const perfil = data;
                localStorage.removeItem('foto');
                localStorage.setItem('foto', perfil.tabla2[0].foto !== "" ? perfil.tabla2[0].foto : process.env.PUBLIC_URL + "/images/default-avatar.png");
                fncPostula();
              } else {
                setLoading(false);
              }
            });
          }
        } else {
          setLoading(false);
        }
      } else {
        setLoading(false);
        Swal.fire({
          icon: 'error',
          title: 'Necesitas aceptar Aviso de Privacidad',
          showConfirmButton: false,
          timer: 1500,
          target: "#modalPostulacion",
        })

      }

    } else {
      setLoading(false);
    }
  }

  useEffect(() => {
    setFrmValues(
      {
        nombre: '',
        apellidoPaterno: '',
        apellidoMaterno: '',
        codigoPostal: '',
        telefono1: '',
        Correo: '',
        CorreoVF: '',
        Password: ''
      }
    )
  }, []);

  return (
    <>
      <FormContainer
        left={false}
        active={active}
        showErrors={errores ? true : false}
      >
        <div className="form">
          <Typography className="title">Registro</Typography>
          <TextField
            error={errores.nombre}
            id="nombre-input"
            label="Nombre"
            helperText={errores.nombre ? errores.nombre : " "}
            type="text"
            value={frmValues.nombre}
            onFocus={() => setErrores({ ...errores, nombre: "" })}
            onChange={(e) => setFrmValues({ ...frmValues, nombre: e.target.value })}
          />
          <div className="columns">
            <TextField
              error={errores.apellidoPaterno}
              id="apP-input"
              label="Apellido Paterno"
              helperText={errores.apellidoPaterno ? errores.apellidoPaterno : " "}
              type="text"
              value={frmValues.apellidoPaterno}
              onFocus={() => setErrores({ ...errores, apellidoPaterno: "" })}
              onChange={(e) => setFrmValues({ ...frmValues, apellidoPaterno: e.target.value })}
            />
            <TextField
              error={errores.apellidoMaterno}
              id="apM-input"
              label="Apellido Materno"
              helperText={errores.apellidoMaterno ? errores.apellidoMaterno : " "}
              type="text"
              value={frmValues.apellidoMaterno}
              onFocus={() => setErrores({ ...errores, apellidoMaterno: "" })}
              onChange={(e) => setFrmValues({ ...frmValues, apellidoMaterno: e.target.value })}
            />
          </div>
          <div className="columns">
            <TextField
              error={errores.codigoPostal}
              id="cp-input"
              label="Código Postal"
              helperText={errores.codigoPostal ? errores.codigoPostal : " "}
              type="text"
              value={frmValues.codigoPostal}
              onFocus={() => setErrores({ ...errores, codigoPostal: "" })}
              onChange={(e) => setFrmValues({ ...frmValues, codigoPostal: e.target.value })}
            />
            <TextField
              error={errores.telefono1}
              id="phone-input"
              label="Celular"
              helperText={errores.telefono1 ? errores.telefono1 : " "}
              type="text"
              value={frmValues.telefono1}
              onFocus={() => setErrores({ ...errores, telefono1: "" })}
              onChange={(e) => setFrmValues({ ...frmValues, telefono1: e.target.value })}
            />
          </div>
          <div className="columns">
            <TextField
              error={errores.Correo}
              id="email-input"
              label="Correo electrónico"
              helperText={errores.Correo ? errores.Correo : " "}
              type="text"
              value={frmValues.Correo}
              onFocus={() => setErrores({ ...errores, Correo: "" })}
              onChange={(e) => setFrmValues({ ...frmValues, Correo: e.target.value })}
            />
            <TextField
              error={errores.CorreoVF}
              id="email2-input"
              label="Verificación de correo"
              helperText={errores.CorreoVF ? errores.CorreoVF : " "}
              type="text"
              value={frmValues.CorreoVF}
              onFocus={() => setErrores({ ...errores, CorreoVF: "" })}
              onChange={(e) => setFrmValues({ ...frmValues, CorreoVF: e.target.value })}
            />
          </div>
          <TextField
            error={errores.Password}
            id="pass-input"
            label="Contraseña"
            helperText={errores.Password ? errores.Password : " "}
            type="password"
            value={frmValues.Password}
            onFocus={() => setErrores({ ...errores, Password: "" })}
            onChange={(e) => setFrmValues({ ...frmValues, Password: e.target.value })}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                submit()
              }
            }}
          />
          <LoadingButton loading={loading} variant="contained" color="primary" className="btnSubmit" onClick={() => submit()}>
            Registrarme y postular
          </LoadingButton>
          <Button className="btnMobile" variant="contained" onClick={() => fncMobile()}>
            Login y postularme
          </Button>
        </div>
      </FormContainer>
    </>
  )
}

export default FrmRegistro;